
<template>

  <div :class="[formGroupClass,'form-group']" @blur="onBlur($event)" @click="clickIn">

    <label class="control-label" v-if="alias">{{ alias }}:</label>

    <div style="position:relative">
      <input 
        type="text"
        autocomplete="new-password"
        v-model="text"
        :class="['form-control', 'form-control-sm']"
        @keydown.self.down.prevent="nextOption"
        @keydown.self.up.prevent="backOption"
        @keyup.enter="selectValue()"
        @focus="onFocus"
        @blur="onBlur($event)"
        v-debounce:400ms="onInput" debounce-events="input"
      />
      
      <i v-if="isLoading" class="fas fa-circle-notch fa-spin text-secondary ss-loading-icon"/>

      <ul 
        role="menu" 
        tabindex="-1" 
        class="dropdown-menu show" 
        style="position: absolute;"
        x-placement="bottom-start"
        v-if="optionsIsVisible"
      >
        
        <template v-for="(row, index) in options">
          <li>
            <a role="menuitem" href="#" class="dropdown-item ss-dropdown-item" :class="[{ 'hovered' : (index == pointer ) }]" @mouseover="setPointer(index)" @click="selectValue()" @keyup.enter="selectValue()"> 
              {{ row[displayedValueProperty] }}
            </a>
          </li> 
        </template>
        
        <li class="dropdown-item" v-if="toShort"> Digite pelo menos 3 caracteres...</li> 

        <li class="dropdown-item" v-if="(isLoading && options == null)"> Carregando...</li>

        <li class="dropdown-item" v-if="notFound"> Nenhum item encontrado</li>

      </ul>
        
    </div>
  </div>

</template>

<script>

//import ClickOutside from 'vue-click-outside'
import Form from './../../mixins/Form.js'

export default {

  props: {

      formGroupClass : {},

      value: {},
      
      displayedValue: {},

      alias: {},

      url : {},
      
      searchParams : {},
      
      valueProperty : {},
      
      displayedValueProperty : {},

  },

  data : function () {
    return {
   
      text : '', // ganbiarra

      options : null,

      pointer : 0,

      optionsIsVisible : false,

      isLoading : false,
      
      toShort : false,
      
      notFound : false,

    }
  },

  computed : {

  },

  mounted() {
    console.log(this.displayedValue)
    this.text = this.displayedValue;
  },

  methods: {
    clickout () {
      console.log('out')
    },

    clickIn() {
      console.log('in')
    },
    onInput() {
      
      this.notFound = false

      this.optionsIsVisible = true

      if (this.text.length > 2) {

        this.search()

        this.toShort = false

      } else {
        
        this.toShort = true

        this.options = null

      }

    },

    onFocus() {
      
      //this.options = null

      //this.optionsIsVisible = true

    },

    onBlur(event) {
      console.log(event)
      console.log(event.relatedTarget.classList)
      //a.dropdown-item.ss-dropdown-item.hovered
      console.log('deu blur')
      
      this.optionsIsVisible = false

    },

    search () {
      
      this.notFound = false

      this.isLoading = true
      
      axios.post(this.url, { city: this.text })
        .then(response => {
          
          if (response.data.length == 0) {
            this.options = null
            this.notFound = true

          } else {

            this.options = response.data
            this.pointer = 0
          }

          this.optionsIsVisible = true
          
          this.isLoading = false
          
        })
        .catch(error => {

          this.error = error

          this.isLoading = false

        })
    },

    setPointer(index) {

      this.pointer = index
    
    },

    nextOption(){

      if (this.pointer < (this.options.length -1)) {
      
        this.pointer++

      }

    },

    backOption(){
      
      if (this.pointer > 0) {
      
        this.pointer--

      }

    },
    
    selectValue() {

      this.text = this.options[this.pointer][this.displayedValueProperty]

      this.$emit('input',  this.options[this.pointer][this.valueProperty])

      this.$emit('selected',  this.options[this.pointer])

      this.options = null

      this.optionsIsVisible = false
      
      

    }

  }
};

</script>

<style lang="scss">

  @import './../../assets/styles/custom.scss';

  .invalid-feedback-overwrite {
    font-size: 12px;

  }

  .hovered {
    background-color: #f8f9fa;
  }

  .ss-loading-icon {
    
    position: absolute;
    top: 8px;
    right: 5px;

  }

  .hovered {
    background-color: $primary;
    color: #fff;
  }

  .ss-dropdown-item:hover {
    background-color: $primary;
    color: #fff;
  }

</style>

